<template>
  <div>
    <div class="landing-page-container">
      <div class="content-box">
        <div class="welcome-text">Welcome to</div>
        <div class="company-name">
          <div>Lifestyle</div>
          <div>Developers</div>
        </div>
        <div class="tagline">part of your dream life</div>
        <button v-scroll-to="'#prop'" class="explore">Explore</button>
      </div>

      <div class="contact-details">
        <div class="child" @click="mailTo">
          <img
            src="../assets/icons/mail.png"
            class="contact-icon"
            alt=""
            srcset=""
          />
          <div class="contact-text">Lifestyledevelopers.kop@gmail.com</div>
        </div>

        <div class="child">
          <img
            src="../assets/icons/phone.png"
            class="contact-icon"
            alt=""
            srcset=""
          />
          <div class="contact-text">+91 9822840096</div>
        </div>
      </div>
    </div>
    <hr />
    <div id="prop" class="projects-container">
      <div class="triangle-bottomright"></div>
      <img class="project-image" src="../assets/landing-page/1.png" />
      <div class="project-info">
        <div class="project-title">Wind Flower</div>
        <div class="project-subtitle">
          A home set amidst abundant greenery. It&#39;s miles from the commotion
          of the city, yet minutes from its comforts.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    whatsappOnClick: function() {
      window.open("https://wa.me/918149444805");
    },
    mailTo: function() {
      window.open("mailto:Lifestyledevelopers.kop@gmail.com");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Poppins", sans-serif;
  /* background-color: black;*/
  /*border: 1px solid red;*/
}

/*project */

.projects-container {
  height: 100vh;
  position: relative;
  filter: drop-shadow(-10px -60px -30px rgba(50, 50, 0, 0.5));
}

.triangle-bottomright {
  /*width: 0;*/
  /*height: 0;*/
  /*border-style: solid;*/
  /*border-width: 0 0 90vh 80vw;*/
  /*border-color: transparent transparent #EEEEEE transparent;*/
  /*position: relative;*/
  /*float: right;*/
  /*box-shadow: -140px 15px 105px rgba(0, 0, 0, 0.25);*/
  /*-------------*/
  clip-path: polygon(100vw 0, 0 100vh, 100vw 100vh);
  background: #eeeeee;
  height: 100vh;
  position: relative;
  /*box-shadow: -140px 15px 105px rgba(0, 0, 0, 0.25);*/
  /*filter: drop-shadow(-15px -15px 30px rgba(0, 0, 200, 0.5));*/
}

.project-info {
  position: absolute;
  top: 10vh;
  left: 10vw;
}

.project-title {
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 5rem;
  /*line-height: 249%;*/
  text-shadow: 33px 18px 27px rgba(0, 0, 0, 0.25);
}

.project-subtitle {
  font-family: Poppins;
  font-style: normal;
  /*font-weight: bold;*/
  font-size: 1.3rem;
  /*line-height: 10%;*/
  width: 30vw;

  text-shadow: 33px 18px 27px rgba(0, 0, 0, 0.25);
}
.project-image {
  position: absolute;
  /* height: 90vh; */
  width: 55vw;
  top: 10vh;
  right: 10vh;
  border-radius: 10px;
}

/*--------*/
.landing-page-container {
  background-image: url("../assets/landing-page-background.png");
  background-repeat: no-repeat;
  height: 100vh;
  /* background-position-y: 13vh;
  background-position-x: 64vw;
  background-size: 40%; */
  /* background-position-x: -20vw; */

  /* background-position-x: 10vh !important; */
  background-position-y: 8vh !important;
  background-position: right;
  background-size: cover;
  padding: 20vh 10vw 10vh 10vw;
}

.content-box {
  height: 52vh;
  width: 30vw;
  /* background: red; */
  /* margin-left: 10vw; */
  /* margin-top: 24vh; */
  position: absolute;
}

.welcome-text {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 2.3rem;
  line-height: 72px;
  padding-bottom: 0.1rem;
}

.company-name > :first-child {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 5rem;
  line-height: 68px;
  color: #005570;
}

.company-name > :nth-child(2) {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 5rem;
  line-height: 68px;
  padding-bottom: 1.5rem;
  color: #005570;
}

.tagline {
  text-transform: capitalize;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 29px;
  padding-bottom: 1.5rem;
}

button.explore {
  background-color: white;
  border: 1px solid black;
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 85%;
  color: #005570;
}
button.explore:hover {
  background-color: #005570;
  color: white;
  cursor: pointer;
  transition: color 200ms;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
}

/* ------------------------------------------ */

.contact-details {
  display: flex;
  height: 10vh;
  width: 60vw;
  /* background-color: red; */
  position: absolute;
  bottom: 0;
}

.contact-icon {
  width: 40px;
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  vertical-align: middle;
}

.contact-text {
  cursor: pointer;
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
  /* background-color: red; */
  /* height: 100%; */
  text-align: center;
}

.child {
  display: inline-block;
}

@media screen and (max-width: 500px) {
  .landing-page-container {
    background-image: none;
    /* background-size: 100vh 100vh; */
    background-repeat: no-repeat;
    height: 100vh;
    background-position-y: 65px;
    background-position-x: -50px;
    background-size: 140%;
    padding: 20vh 0 0 10vw;
  }

  .content-box {
    height: auto;

    width: 50vw;
  }
  .welcome-text {
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 39px;
  }
  .company-name > :first-child {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 2.5rem;
    line-height: 2rem;
  }

  .company-name > :nth-child(2) {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 2.5rem;
    line-height: 2rem;
    padding-bottom: 1.5rem;
  }
  .tagline {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    padding-bottom: 1.5rem;
  }
  button.explore {
    background-color: white;
    border: 2px solid black;
    padding: 0.5rem 1rem 0.5rem 1rem;
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    /* line-height: 85%; */
  }

  /* contact details */
  .contact-details {
    flex-direction: column;
    height: 10vh;
    width: 90vw;
    /* background-color: red; */
    position: absolute;
    bottom: 8vh;
  }
  .child {
    display: block;
    padding-bottom: 10px;
  }
  .contact-icon {
    width: 30px;
    display: inline-block;
    margin-right: 10px;

    vertical-align: middle;
  }
  /*  projects*/
  .projects-container {
    height: 80vh;
    position: relative;
    filter: drop-shadow(-10px -60px -30px rgba(50, 50, 0, 0.5));
  }

  .triangle-bottomright {
    clip-path: polygon(100vw 0, 0 80vh, 100vw 80vh);
    background: #eeeeee;
    height: 100vh;
    position: relative;
  }

  .project-info {
    position: absolute;
    top: 10vh;
    left: 10vw;
  }

  .project-title {
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 2.5rem;
    /*line-height: 249%;*/
    text-shadow: 33px 18px 27px rgba(0, 0, 0, 0.25);
  }

  .project-subtitle {
    font-family: Poppins;
    font-style: normal;
    /*font-weight: bold;*/
    font-size: 1rem;
    /*line-height: 10%;*/
    width: 80vw;

    text-shadow: 33px 18px 27px rgba(0, 0, 0, 0.25);
  }
  .project-image {
    position: absolute;
    /* height: 80vw; */
    width: 90vw;
    top: 35vh;
    right: 2vw;
    border-radius: 20px;
  }
  /*  /////*/
}
@media screen and (max-width: 375px) {
  .contact-details {
    flex-direction: column;
    /*height: 10vh;*/
    /*width: 90vw;*/
    /*background-color: red;*/
    position: absolute;
    bottom: 12vh;
  }
  .landing-page-container {
    background-image: none;
    /* background-size: 100vh 100vh; */
    /* background-repeat: no-repeat;
    height: 100vh;
    background-position-y: 10vh;
    background-position-x: -10vw;
    background-size: 200%;
    padding: 20vh 0 0 10vw; */
  }

  .projects-container {
    height: 90vh;
    position: relative;
    filter: drop-shadow(-10px -60px -30px rgba(50, 50, 0, 0.5));
  }

  .triangle-bottomright {
    clip-path: polygon(100vw 0, 0 90vh, 100vw 90vh);
    background: #eeeeee;
    height: 100vh;
    position: relative;
  }

  .project-image {
    position: absolute;
    height: 80vw;
    top: 40vh;
    right: 2vw;
    border-radius: 20px;
  }

  .contact-text {
    font-size: 0.8rem;
  }
}
</style>
